import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import {
    NgForm,
    FormGroup,
    FormControl,
    FormArray,
    Validators,
    ValidatorFn,
    AsyncValidatorFn
} from '@angular/forms';
import { FormInlineRowComponent } from './../forms/form-inline-row';
import { UserService } from './user-service';
import { MessageComponent, BaseComponent } from './../common/common-components';
import { ModalService } from "../services/modal-service";
import { BankAccountService } from "./../accounts/bank-account-service";
declare var ga: any;

@Component({
    selector: 'dk-user-transfer-title',
    template: require('./user-transfer-title.html'),
    entryComponents: [FormInlineRowComponent]
})

export class UserTransferTitleComponent extends BaseComponent implements OnInit {
    changeSuccess: boolean;
    changeFailure: boolean;
    public errorMessageId: string;
    @Input() smsMode: boolean;
    @Output() smsModeChange = new EventEmitter<boolean>();

    form: FormGroup = new FormGroup({
        TransferTitle: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(120)]),
        SmsCode: new FormControl('')
    });

    constructor(private bankAccountService: BankAccountService,
        private modalService: ModalService,
        private userService: UserService) {
        super();
    }

    load() {
        this.userService.account().subscribe(data => {
            this.initFormGroup(this.form, data);
        });
    }

    ngOnInit() {
        this.load();
    }

    submit() {
        if (this.smsMode == true) {
            return;
        }

        this.touchFormGroup(this.form);

        if (this.form.valid) {
            this.errorMessageId = null;
            this.changeSuccess = false;
            this.changeFailure = false;
            this.bankAccountService.isAccountBankCodeChangeLocked().subscribe(isLocked => {
                if (isLocked) {
                    this.smsMode = true;
                    this.smsModeChange.emit(this.smsMode);
                    this.modalService.sendSmsCode();
                    this.form.controls['SmsCode'].setValue('');
                }
                else {
                    this.userService.changeTransferTitle(this.form.value).subscribe(result => {
                        if (result) {
                            this.changeSuccess = true;
                            ga('send', 'event', 'user', 'zmieniono-tytul-przelewu', null, null, this.form.value);
                            this.load();
                        } else {
                            this.changeFailure = true;
                        }
                    });
                }
            });
        }
    }

    back() {
        this.smsMode = false;
        this.smsModeChange.emit(this.smsMode);
    }

    confirmWithSms() {
        this.touchFormGroup(this.form);

        if (this.form.valid) {
            this.changeSuccess = false;
            this.changeFailure = false;
            let code = this.form.controls['SmsCode'].value;
            this.userService.changeTransferTitle(this.form.value, code).subscribe(result => {
                if (result) {
                    this.changeSuccess = true;
                    this.load();
                } else {
                    this.changeFailure = true;
                    this.errorMessageId = '1002';
                }
            });
            this.smsMode = false;
            this.smsModeChange.emit(this.smsMode);
            this.form.controls['SmsCode'].setValue('');
        }
    }
}
